module.exports = __webpack_public_path__ + "img/robot_gif4.000368b2.000368b2.gif";